import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/adherenthlsession`;

/* ===== Headers + helpers ===== */
const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const buildQuery = (params = {}) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    usp.append(k, String(v));
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
};

export const toAbsoluteAdherentPhotoUrl = (rel) => {
  if (!rel) return null;
  if (/^https?:\/\//i.test(rel)) return rel;
  const base = process.env.REACT_APP_API_URL || "";
  const slash = rel.startsWith("/") ? "" : "/";
  return `${base}${slash}${rel}`;
};

/* ===== GET ===== */
// Récupérer toutes les séances (filtres optionnels)
// filters: { adherent_id, categorie_seance, is_done, date_from, date_to }
export const getAllHighLevelSessions = async (filters = {}) => {
  try {
    const url = `${apiUrl}/all${buildQuery(filters)}`;
    const response = await axios.get(url, { headers: authHeaders() });

    // Ajout d’une URL absolue pour la photo adhérent (si présente)
    const data = Array.isArray(response.data) ? response.data : [];
    return data.map((it) => {
      if (it?.adherent?.photo_url) {
        return {
          ...it,
          adherent: {
            ...it.adherent,
            photo_url_abs: toAbsoluteAdherentPhotoUrl(it.adherent.photo_url),
          },
        };
      }
      return it;
    });
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des séances haut niveau :",
      error
    );
    throw error;
  }
};

export const getHighLevelSessionsByAdherent = async (
  adherentId,
  filters = {}
) => {
  if (!adherentId) throw new Error("adherentId requis");
  try {
    const url = `${apiUrl}/by-adherent/${adherentId}${buildQuery(filters)}`;
    const res = await axios.get(url, { headers: authHeaders() });

    const data = Array.isArray(res.data) ? res.data : [];
    return data.map((it) => {
      if (it?.adherent?.photo_url) {
        return {
          ...it,
          adherent: {
            ...it.adherent,
            photo_url_abs: toAbsoluteAdherentPhotoUrl(it.adherent.photo_url),
          },
        };
      }
      return it;
    });
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des séances par adhérent :",
      error
    );
    throw error;
  }
};

/* ===== POST ===== */
// Créer une nouvelle séance
// payload: { adherent_id, seance_date, categorie_seance, nom_seance?, lieu_seance?, duree_minutes?, qualite_note?, observations_seance?, is_done? }
export const createHighLevelSession = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}/create`, payload, {
      headers: authHeaders(),
    });
    const it = response.data;
    if (it?.adherent?.photo_url) {
      it.adherent.photo_url_abs = toAbsoluteAdherentPhotoUrl(
        it.adherent.photo_url
      );
    }
    return it;
  } catch (error) {
    console.error(
      "Erreur lors de la création de la séance haut niveau :",
      error
    );
    throw error;
  }
};

/* ===== PUT ===== */
// Mettre à jour une séance existante
export const updateHighLevelSession = async (id, payload) => {
  try {
    const response = await axios.put(`${apiUrl}/update/${id}`, payload, {
      headers: authHeaders(),
    });
    const it = response.data;
    if (it?.adherent?.photo_url) {
      it.adherent.photo_url_abs = toAbsoluteAdherentPhotoUrl(
        it.adherent.photo_url
      );
    }
    return it;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour de la séance haut niveau :",
      error
    );
    throw error;
  }
};

/* ===== DELETE ===== */
// Supprimer une séance
export const deleteHighLevelSession = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/delete/${id}`, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la suppression de la séance haut niveau :",
      error
    );
    throw error;
  }
};
